export const BRANCH_OFFICE_CLOSED = '(agencia cerrada)';
export const PUBLIC_SITE_ORIGIN = 'PUBLICO';
export const DRP_BYPASS = 'publicsite-drp.planvital.cl';
